<template>
  <div class="point-history-card">
    <div class="stats-panel-card">
      <div class="course-card-body">
        <div class="card-header">
          <h4 class="card-title">
            <i class="uil-history"></i>
            <span>{{ $t("collectionDetail.share_history") }}</span>
          </h4>
        </div>

        <div v-if="loading" class="history-content">
          <div class="list-head">
            <span class="list-head__activity">{{ $t("general.activity") }}</span>
            <span class="list-head__points">{{ $t("general.points_i_earned") }}</span>
            <span class="list-head__action"></span>
          </div>
          <ul class="history-list">
            <li v-for="n in 8" :key="'skeleton_' + n" class="history-item skeleton-item">
              <div class="activity-info">
                <div class="skeleton skeleton-icon"></div>
                <div class="skeleton skeleton-text"></div>
              </div>
              <div class="skeleton skeleton-point"></div>
              <div class="skeleton skeleton-btn"></div>
            </li>
          </ul>
        </div>

        <div v-else-if="!userPoints.length" class="history-empty">
          <i class="uil-inbox"></i>
          <p>{{ $t("general.no_result_found") || "Veri bulunamadı" }}</p>
        </div>

        <div v-else class="history-content">
          <div class="list-head">
            <span class="list-head__activity">{{ $t("general.activity") }}</span>
            <span class="list-head__points">{{ $t("general.points_i_earned") }}</span>
            <span class="list-head__action"></span>
          </div>
          <ul class="history-list">
            <li
              v-for="(item, index) in userPoints"
              :key="'user_point_history_item_' + index"
              class="history-item"
            >
              <div class="activity-info">
                <span class="activity-icon" aria-hidden="true">
                  <i :class="item.point_category.icon ? item.point_category.icon : 'uil-award'"></i>
                </span>
                <span class="activity-name">{{ $t(item.point_category.key_name) }}</span>
              </div>
              <span class="point-cell">
                <strong>{{ item.point }}</strong>
                <span class="point-unit">{{ $t("gift.point") }}</span>
              </span>
              <button
                class="detail-btn"
                type="button"
                :aria-label="$t('general.details')"
                @click="$emit('detail-click', item.id)"
              >
                <span class="btn-text">{{ $t("general.details") }}</span>
                <i class="uil-angle-right"></i>
              </button>
            </li>
          </ul>
        </div>

        <div v-if="pagination && pagination.last_page > 1" class="pagination-footer">
          <pagination
            :max-visible="isMobile ? 2 : 7"
            :pagination="pagination"
            :use-icons="true"
            @changePage="$emit('change-page', $event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/assets/components/Pagination.vue";

export default {
  name: "PointHistory",
  components: { Pagination },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    userPoints: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: null,
    },
    windowWidth: {
      type: Number,
      default: 1200,
    },
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
  },
};
</script>

<style scoped>
.point-history-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.stats-panel-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  overflow: hidden;
}

.course-card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
  min-width: 0;
}

.card-header {
  min-height: 0 !important;
  height: auto !important;
  padding: 0 0 8px !important;
  margin: 0 0 12px !important;
  border-bottom: 1px solid #e5e7eb;
  background: transparent;
}

.card-title {
  margin: 0;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.3;
  color: #0f172a;
}

.card-title i {
  flex-shrink: 0;
  margin-top: 1px;
  color: #64748b;
}

.history-content {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.list-head {
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: 12px;
  padding: 0 4px 8px;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
  border-bottom: 1px solid #e2e8f0;
}

.list-head__points {
  text-align: right;
  min-width: 72px;
}

.list-head__action {
  width: 88px;
}

.history-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.history-item {
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: 12px;
  padding: 11px 4px;
  border-bottom: 1px solid #f1f5f9;
}

.history-item:last-child {
  border-bottom: none;
}

.activity-info {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.activity-icon {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  flex-shrink: 0;
}

.activity-icon i {
  font-size: 15px;
  line-height: 1;
}

.activity-name {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #334155;
  line-height: 1.35;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.point-cell {
  display: inline-flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 4px;
  min-width: 72px;
  text-align: right;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.point-cell strong {
  font-size: 0.875rem;
  font-weight: 700;
  color: #0f172a;
}

.point-unit {
  font-size: 0.6875rem;
  font-weight: 500;
  color: #94a3b8;
}

.detail-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 88px;
  padding: 6px 10px;
  font-size: 0.75rem;
  font-weight: 500;
  color: #475569;
  background: transparent;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.detail-btn:hover {
  border-color: #cbd5e1;
  color: #0f172a;
  background: transparent;
}

.detail-btn i {
  font-size: 14px;
  line-height: 1;
}

.history-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 180px;
  color: #94a3b8;
  text-align: center;
}

.history-empty i {
  font-size: 2rem;
  color: #cbd5e1;
}

.history-empty p {
  margin: 0;
  font-size: 0.875rem;
}

.pagination-footer {
  flex-shrink: 0;
  padding: 12px 0 0;
  border-top: 1px solid #e5e7eb;
  margin-top: 12px;
}

/* Skeleton */
.skeleton {
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.skeleton-item {
  pointer-events: none;
}

.skeleton-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  flex-shrink: 0;
}

.skeleton-text {
  width: 140px;
  height: 12px;
}

.skeleton-point {
  width: 56px;
  height: 12px;
  justify-self: end;
}

.skeleton-btn {
  width: 88px;
  height: 30px;
  border-radius: 8px;
}

@media (max-width: 1024px) {
  .course-card-body {
    padding: 14px;
  }
}

@media (max-width: 768px) {
  .course-card-body {
    padding: 14px;
  }

  .card-header {
    margin-bottom: 10px !important;
  }

  .card-title {
    font-size: 0.875rem;
  }

  .list-head,
  .history-item {
    gap: 10px;
  }

  .list-head__action,
  .detail-btn {
    min-width: 36px;
    width: 36px;
  }

  .btn-text {
    display: none;
  }

  .detail-btn {
    padding: 6px;
  }

  .activity-name {
    font-size: 0.8125rem;
  }
}

@media (max-width: 576px) {
  .course-card-body {
    padding: 14px 12px;
  }

  .list-head__points,
  .point-cell {
    min-width: 56px;
  }

  .activity-icon {
    width: 28px;
    height: 28px;
    border-radius: 7px;
  }

  .activity-icon i {
    font-size: 14px;
  }

  .activity-name {
    font-size: 0.75rem;
  }

  .point-cell strong {
    font-size: 0.8125rem;
  }

  .skeleton-icon {
    width: 28px;
    height: 28px;
  }

  .skeleton-text {
    width: 100px;
  }

  .skeleton-btn {
    width: 36px;
  }
}

@media (max-width: 576px) {
  .history-item {
    min-height: 48px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .activity-name {
    font-size: 14px;
    line-height: 1.4;
  }

  .point-cell,
  .point-unit {
    font-size: 12px;
    line-height: 1.4;
  }

  .detail-btn {
    min-width: 48px;
    width: 48px;
    min-height: 48px;
    height: 48px;
  }
}
</style>
